import Login2Container from "../../../components/pages/other/Login2";

const Login2 = () => {
  return <Login2Container />;
};

export default Login2;
